import Vue from 'vue'
import { imgDomain } from '../configs/env'

Vue.filter('imgMapper', value => imgDomain + value)



// WEBPACK FOOTER //
// ./src/filters/vue-filiter.js